import React, { useState, useEffect } from "react";
// import history from "../../routes/history";
import { useDispatch, useSelector } from "react-redux";

import "./ProfessionNew.css";
import {Row,Col,Divider,Spin} from 'antd';
import healthCareIcon from "../../assets/icons/healthCareICON.svg";
import IT_icon from "../../assets/icons/IT_ICON.svg";
import freelancer from "../../assets/icons/IT_Freelancer_ICON.svg";
import {resetCompanyProfileDetails, updateCompanyProfileDetails} from "../../redux/actions";
import Loader from "../../components/Loading/Loader";
import { useHistory } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { setCookie } from "../../shared/helpers";

const Profession = () => {

  const dispatch = useDispatch();
  const hist = useHistory();

  const loading = useSelector((state) => state.getCompanyDetailsReducer.loading);
  const success = useSelector((state) => state.getCompanyDetailsReducer.success);
  const profile = JSON.parse(localStorage.getItem('userProfile'));


  const updateProfession = (ProfessionCode) => {
    // console.log("ProfessionCode:", ProfessionCode);
    dispatch(
      updateCompanyProfileDetails(
        { Professions:{ProfessionCode} }
      )
    );
  };


  useEffect(()=>{
    if(success){
      if(profile.Profiles.CompanyName !== null) {
        
        if(profile.profiles?.LastName && profile.profiles.LastName!==null){
        hist.push('/employerdashboard')
        setCookie('finishProfile', 'true');
        }
        else{ 
          dispatch(resetCompanyProfileDetails())
          hist.push('/companydetails')}

      }else{
        dispatch(resetCompanyProfileDetails())
        hist.push('/companydetails')
      }
    }
  },[success])

  return (
    // <div className="ProfessionPage">
    //   {loading?<div className="loader-profession-div"  ><LoadingOutlined className="loader-profession"/></div>:
    //   <div className="profession">
    //     <div className="professionHeader">
    //       <div style={{ width: "19.1rem" }}>
    //         <div className="preferenceHeader">Choose a marketplace category</div>
    //         <div className="preferenceSub">
    //         Choose one of our marketplace categories that best fits where you'll find the perfect candidate for your open gigs.
    //         </div>
    //       </div>
    //     </div>
    //     {/* <section className="alignProfession"> */}
    //     <Row className="chooseProfession">
    //       <Col xs={11} sm={11} md={7} className="healthCarePro" onClick={() => updateProfession("HC")}>
    //         <img src={healthCareIcon} alt="healthCareIcon" style={{width:'80%', marginLeft:'10%', marginBottom:'5%'}}/>
    //         <Divider style={{marginTop:'0%'}}/>
    //         <div className="professionText">Health care</div>
    //         <div className="professionSubText">Our healthcare professionals range <br/>from registered nurses and travel <br/>nurses to therpaists.</div>
    //       </Col>
    //       <Col md={7} xs={11} sm={11} className="InfoTPro" onClick={() => updateProfession("IT")}>
    //         <img src={IT_icon} alt="IT_icon" style={{width:'80%', marginLeft:'10%', marginBottom:'5%'}}/>
    //         <Divider style={{marginTop:'0%'}}/>
    //         <div className="professionText">IT</div>
    //         <div className="professionSubText"> Our IT professionals range from <br/>developers and designers to project <br/>managers.</div>
    //       </Col>
    //       {/* <Col xs={11} md={7} sm={11}
    //         className="ITFreelancerPro"
    //         onClick={() => updateProfession("FL")}
    //       >
    //         <img src={freelancer} alt="freelancer" style={{width:'80%', marginLeft:'10%', marginBottom:'5%'}}/>
    //         <Divider style={{marginTop:'0%'}}/>
    //         <div className="professionText">Freelancer</div>
    //       </Col> */}
    //     </Row>
    //     {/* </section> */}
    //   </div> }
    // </div>
    <div className="ProfessionPage">
      {loading ? <div className="loader-profession-div"><LoadingOutlined className="loader-profession" /></div> :
        <div className="ProfessionPage">
          <div className="profession">
            <div className="professionHeader">
              <div style={{ width: "19.1rem" }}>
                <div className="preferenceHeader">Choose a marketplace category</div>
                <div className="preferenceSub">
                  Choose one of our marketplace categories that best fits where you'll find the perfect candidate for your open gigs.
                </div>
              </div>
            </div>
            {/* <section className="alignProfession"> */}
            <div className="chooseProfession">
              <div
                className="healthCarePro"
                onClick={(e) => {
                  e.stopPropagation();
                  // gtag_report_conversion_hc();
                  updateProfession("HC");
                }}
                style={{border: profile?.Professions?.ProfessionCode ==='HC' && 'solid 1px #118936'}}
              >
                <div>
                  {" "}
                  <img src={healthCareIcon} alt="healthCareIcon" />{" "}
                </div>
                <span className="professionDivider"></span>
                <div className="professiontxt">
                  {" "}
                  <span className="professionText">Healthcare</span>
                  <div className="professionSubText">
                    Our healthcare professionals range <br />
                    from registered nurses and travel <br />
                    nurses to therpaists.{" "}
                  </div>{" "}
                </div>
              </div>

              <div
                className="InfoTPro"
                onClick={() => {
                  // gtag_report_conversion_it();
                  updateProfession("IT");
                }}
                style={{border: profile?.Professions?.ProfessionCode ==='IT' && 'solid 1px #118936'}}
              >
                <div>
                  {" "}
                  <img src={IT_icon} alt="IT_icon" />{" "}
                </div>
                <span className="professionDivider"></span>
                <div className="professiontxt">
                  {" "}
                  <span className="professionText">IT</span>
                  <div className="professionSubText">
                    {" "}
                    Our IT professionals range from <br />
                    developers and designers to project <br />
                    managers.
                  </div>{" "}
                </div>
              </div>
              {/* <div
            className="ITFreelancerPro"
            onClick={() => updateProfession("FL")}
          >
            <img src={freelancer} alt="freelancer" />
            <span className="professionDivider"></span>
            <span className="professionText">IT Freelancer</span>
          </div> */}
            </div>
            {/* </section> */}
          </div>
        </div>}
    </div>
  );
};

export default Profession;